<template>
    <v-dialog
        v-model="dialog"
        max-width="900"
        content-class="spillard-dialog"
    >
        <v-card>
            <div class="close" @click="dialog = !dialog">
                <i class="material-icons">close</i>
            </div>
            <v-card-title v-if="vehicle">
                <div class="icon-slot">
                    <icon class="logout-icon" icon="video" :height="20" :width="20" />
                </div>
                <div class="reg-number">
                    aaaaaaReg Number: <span class="text-bold">{{ this.vehicle.driverName || 'Any' }} / {{ this.vehicle.registrationNumber || 'Unknown' }}</span>
                </div>
                <div class="make">
                    Make: <span class="text-bold">{{ this.vehicle.manufacturer }}</span>
                </div>
                <div class="make">
                    Model: <span class="text-bold">{{ this.vehicle.model }}</span>
                </div>
                <div class="make">
                    Engine size: <span class="text-bold">{{ this.vehicle.engineSize }}</span>
                </div>
                <div class="make">
                    Year: <span class="text-bold">{{ this.vehicle.yearOfManufacture }}</span>
                </div>
            </v-card-title>
            <v-card-text class="snapshot-content" v-if="snapshot">
                <div class="snapshot-details">
                    <div class="details">
                        <div class="requested-date">Requested: <span class="text-bold">{{ date(snapshot.createdOn) }}</span></div>
                        <div class="event">Type: <span class="text-bold">{{ snapshot.snapshotType.name }}</span></div>
                    </div>
                    <div class="details">
                        <div class="device-id">Device ID: <span class="text-bold">{{ snapshot.recorderId }}</span></div>
                    </div>
                </div>

                <div class="images">
                    <v-carousel :cycle="false" :height="500" v-if="snapshotImages.length > 0">
                        <v-carousel-item v-for="item in snapshotImages" :key="item.id">
                            <div v-if="snapshot.type === 2" class="imageBox" :style="{ 'background-image': `url('${item.url}')` }"></div>
                            <v-sheet v-if="snapshot.type === 1"
                                     height="100%"
                                     width="828px"
                                     color="white"
                            >
                                <video controls>
                                    <source :src="item.url" :type="item.contentType">
                                </video>
                            </v-sheet>
                        </v-carousel-item>
                    </v-carousel>
                    <div class="no-media" v-if="snapshotImages.length === 0">
                        No media available for this snapshot, try again later
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import SnapshotService from './../../../services/SnapshotService'
import VehicleService from './../../../services/VehicleService'
import EnumsManager from './../../../menagers/EnumsManager'
import { mapState } from 'vuex'
import { formatDate } from '@/helpers/Utils'
import Icon from '@/components/atoms/Icon'

export default {
    name: 'SnapshotDialog',
    components: {
        Icon
    },
    data () {
        return {
            dialog: false,
            snapshot: null,
            snapshotImages: [],
            vehicle: null,
            model: 0
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        snapshotId: {
            type: [String, null]
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', this.dialog)
            }
        },
        ...mapState([
            'snapshotTypes'
        ])
    },
    watch: {
        value: {
            handler () {
                if (this.value) {
                    this.snapshotImages = []
                    this.getSnapshot()
                }

                this.dialog = this.value
            }
        },
        dialog (val) {
            this.$emit('input', val)
        }
    },
    methods: {
        date (value) {
            return formatDate(value)
        },
        async getSnapshot () {
            try {
                const response = await SnapshotService.getSnapshot(this.snapshotId)

                this.snapshot = response.data
                this.snapshot.snapshotType = EnumsManager.searchById(this.snapshotTypes, this.snapshot.type)
                this.snapshotImages = this.snapshot.mediaList

                await this.getVehicle(this.snapshot.vehicleId)
            } catch (e) {
                this.dialog = false
            }
        },
        async getVehicle (vehicleUuid) {
            const response = await VehicleService.getVehicleByUuid(vehicleUuid)
            this.vehicle = response.data
        }
    }
}
</script>

<style scoped lang="scss">
.imageBox {
    display: flex;
    width: 100%;
    height: 100%;
    background-size: contain;
}

.snapshot-dialog {
    border-radius: 0 !important;

    .v-sheet {
        border-radius: 0;
    }

    .v-card__title {
        height: 50px;
        background: #F5F5F5;
        padding: 0;
        font-size: 14px;
        font-weight: 400;

        div {
            margin-right: 20px;
        }

        .icon {
            width: 50px;
            height: 50px;
            background-color: $secondary;
            background-repeat: no-repeat;
            background-position: center;
            color: $font;

            &.video {
                background-image: url('./../../../assets/icons/icon-video-white.svg');
            }
        }
    }

    .snapshot-content {
        .snapshot-details {
            margin: 10px 70px;

            .details {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                margin-bottom: 10px;

                div {
                    width: 50%;
                }
            }
        }

        .video,
        .images {
            margin: 0 20px 20px 20px;
            text-align: center;

            video {
                margin: 0 auto;
                height: calc(100% - 50px);
            }

            .no-media {
                border: 1px solid $light-gray;
                padding: 90px 0;
            }
        }
    }
}

.close {
    position: absolute;
    top: 14px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
</style>
